<template>
    <div id="cat">
      <div class="vx-card">
        <div class="vx-card__body card-body">
          <div class="vx-row mb-6">
            <div class="vx-col w-full mb-2">
              <vs-button @click="createAccount()" class="bg_l_green" v-has-permission="'CreateCostCenter'">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
                {{ $t("CreateCostCenter") }}
              </vs-button>
            </div>
          </div>
          <modify-popup
            :show="ModifyPopup"
            :model="modalModel"
            :parentId="parentId"
            :parentCode="parentCode"
            @finish="onfinish"
            @close="closeModifyPopup"
          >
          </modify-popup>
  
          <div class="vx-row">
            <div class="vx-col w-full mb-base">
              <data-grid
                ref="grid"
                stripe
                :data-source="gridDataSource"
                :search-data="gridSearchData"
                :columns="[
                  {
                    title: $t('CostCenterTitle'),
                    sort: 'CostCenterTitle',
                  },
                  { title: $t('Code'), sort: 'Code' },
                  { title: $t('Description'), sort: 'Description' },
                  { title: $t('Action') },
                ]"
              >
                <template slot-scope="{ row }">
                  <td>
                    {{ row.name }}
                  </td>
                  <td style="direction: ltr">
                    {{ row.code }}
                  </td>
                  <td>
                    {{ row.description ? row.description : "-" }}
                  </td>
  
                  <td>
                    <router-link
                      :to="{
                        path: `/CreditManagement/CostCenter/Connections/${row.id} `,
                        query: {
                          breadcrumbNameManual: {
                            persianTitleParent: row.name,
                          },
                        },
                      }"
                      v-has-permission="permissions234"
                    >
                    <vs-button
                      color="warning"
                      size="small"
                      type="gradient"
                      class="ml-4 d-inline"
                      >ارتباطات</vs-button
                    >
                    </router-link>
                    <vs-button
                  radius
                  color="danger"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-x"
                  v-has-permission="'DeleteCostCenter'"
                  @click.prevent="deleteCostCenter(row.id)"
                  class="d-inline"
                ></vs-button>
                  </td>
                </template>
              </data-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
  import DataGrid from "@/components/datagrid/DataGrid";
  import ModifyPopup from "./CreateCostCenterPopup.vue";
  
  import moment from "moment";
  export default {
    components: {
      ModifyPopup,
      DataGrid,
    },
    data() {
      return {
        permissions234:"GetAllCostCentersByParentAccountId|GetAllAccountReferenceInfos|AssignAccountReference",
        ModifyPopup: false,
        parentName: "",
        parentCode: "",
        parentId: 0,
        modalModel: {},
        itemList: [],
        gridDataSource: {
          type: "app",
          service: "Credits/api/CostCentersQuery/by-paging"
        },
        gridSearchData: {
          keyword: "",
        },
      };
    },
    mounted() {
      this.parentName = this.$route.query.parentName;
      this.parentCode = this.$route.query.parentCode;
      this.parentId = this.$route.params.id;
      setTimeout(() => {
        this.loaded = true;
      }, 1000);
    },
    methods: {
      ...mapActions({
        removeAccount: "costCenter/delete",
      }),
      ////Open Modal In Create Mode
      createAccount() {
        this.modalModel = {};
        this.ModifyPopup = true;
      },
  
      //Open Modal In Edit Mode
      editAccount(model) {
        this.getData(model.id);
        this.modalModel = {
          id: model.id,
          title: model.title,
          startClock: model.startClock,
          expireClock: model.expireClock,
          description: model.description,
          connectedAccounts: model.parentAccountInfos,
        };
        this.ModifyPopup = true;
      },
      //Delete Method
      deleteCostCenter(id) {
        this.$swal({
          title: "آیا از حذف این رکورد اطمینان دارید؟",
          type: "warning",
  
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بلی",
          cancelButtonText: "خیر",
        }).then((result) => {
          if (result.value) {
            this.removeAccount(id).then(() => {
              this.$refs.grid.renderGrid();
            });
          }
        });
      },
      closeModifyPopup() {
        this.ModifyPopup = false;
      },
      onfinish() {
        this.closeModifyPopup();
        this.$refs.grid.renderGrid();
      },
    },
  };
  </script>
  